// --------------------Quick Fixes----------------------//

function modifyBtnNavToggle() {
  const navToggle = $('.mobile-nav-toggle');
  const bars = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="#0063a6" width="40" height="36"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"/></svg>`;
  navToggle.html(bars);
  navToggle.attr('tabindex', '0');
  navToggle.attr('role', 'button');
  navToggle.attr('aria-label', 'open menu');
}

function searchBoxPlaceholder() {
  const searchInput = $('.searchBoxInput input');
  // set a placeholder to searchInput
  searchInput.attr('value', '');
  searchInput.attr('placeholder', 'Type here...');
}

function wrapDirections() {
  const directionsPins = $('.directionsPin');
  const directionsText = $('.standAloneDirections');
  const directionsIcon = `<svg class="link-icon" xmlns="http://www.w3.org/2000/svg"  height="20" width="15" viewBox="0 0 384 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/></svg>`;

  const directionsWrapper = $('<div class="directionsWrapper"></div>');
  directionsPins.html(directionsIcon);
  directionsPins.appendTo(directionsWrapper);
  directionsText.appendTo(directionsWrapper);
  directionsWrapper.prependTo('.header .top-links li:nth-child(2)');
}

function wrapLogin() {
  const memberIcon = `<svg class="link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height="20" width="15">
  <path d="M224 16c6.7 0 10.8-2.8 15.5-6.1C246.1 5.4 254 0 272 0c35.2 0 58.3 58.1 72 110.4C316.4 120 277 128 224 128s-92.4-8-120-17.6C117.7 58.1 140.8 0 176 0c18 0 25.9 5.4 32.5 9.9c4.7 3.3 8.8 6.1 15.5 6.1zM8.6 97.8c7-3.6 15.5-1.7 20.2 4.6c5.6 7.5 22.7 22 55 34.7C115.8 149.6 161.8 160 224 160s108.2-10.4 140.2-22.9c32.4-12.7 49.4-27.2 55-34.7c4.7-6.3 13.3-8.2 20.2-4.6s10.2 11.8 7.8 19.2c-9.3 27.9-35 62.4-72.5 89.9c-7.1 5.2-14.7 10.1-22.7 14.8c0 .8 0 1.5 0 2.3c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-.8 0-1.5 0-2.3c-8-4.6-15.6-9.6-22.7-14.8C35.8 179.5 10.1 145 .8 117.1c-2.5-7.4 .8-15.6 7.8-19.2zM100.7 384l246.5 0c48.4 0 89.3 36.1 95.3 84.1l1 7.9c2.4 19.1-12.5 36-31.8 36L36.3 512C17 512 2.1 495.1 4.5 476l1-7.9c6-48 46.8-84.1 95.3-84.1z"/></svg>`;
  const logOutIcon = `
  <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 512 512">
  <path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"/></svg>
  `;
  const loginLink = $('.login-status-link');
  const myAccount = $('.my-account-link');

  const memberLoginContent = memberIcon + 'Member Login';
  const logOutContent = logOutIcon + 'Sign Out';
  const myAccountContent = memberIcon + 'My Account';

  const updateLinkText = (element, currentText, newContent) => {
    if (element.text() === currentText) {
      element.html(newContent);
    }
  };

  updateLinkText(loginLink, 'Log In', memberLoginContent);
  updateLinkText(loginLink, 'Log Out', logOutContent);
  updateLinkText(myAccount, 'My Account', myAccountContent);
}

function appendSEOTitle() {
  const seoEmpty =
    $('body').hasClass('seoTextWidget-no-data') && $('body').hasClass('seoCardsWidget-no-data');
  if (seoEmpty) {
    $('.seo-section').append(
      '<h1 class="no-seo-title" aria-label="Welcome to Kentucky Association of Fairs and Horse Shows">Welcome to Kentucky Association of Fairs and Horse Shows</h1>',
    );
  }
}

// --------------------Lineup modifier----------------------//
function modifyFeatureLineup() {
  function cropText(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) : text;
  }

  function createContentWrapper(titleText, croppedTitle, descriptionText) {
    return `
      <span class="featureLineup-content">
        <h4 class="featureLineup-content-title" title="${titleText}" aria-label="${titleText}">${croppedTitle}</h4>
        ${descriptionText ? `<span class="featureLineup-content-description">${descriptionText}</span>` : ''}
      </span>
    `;
  }

  function lineupButtonsGrid(lineup) {
    const containerSize = lineup.width();
    const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
    const icons = buttonContainer.find('.featureLineup-social');
    const buttons = buttonContainer.find('.featureLineup-buynow');

    // if icons length + buttons length is greater than containerSize then add class "grid" to buttonContainer

    if (icons.width() + buttons.width() > containerSize - 20) {
      buttonContainer.addClass('column');
    }

    // remove icons if there 0 children
    if (!icons.children().length) {
      icons.remove();
    }
  }

  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);
    const $imageContainer = $element.find('.featureLineupImage');
    const $title = $element.find('.featureLineup-title');
    const $description = $element.find('.featureLineup-text');
    const $moreBtn = $element.find('.featureLineup-more');

    const titleText = $title.text().trim();
    const croppedTitle = cropText(titleText, 35);
    const descriptionText = $description.text().trim();

    const contentWrapper = createContentWrapper(titleText, croppedTitle, descriptionText);
    const wrapperAux = `
    <span class="featureLineup-text">
      ${contentWrapper}
    </span>
    `;

    $title.remove();
    $description.remove();
    lineupButtonsGrid($element);
    $imageContainer.append(wrapperAux);
    $imageContainer.find('.featureLineup-content').append($moreBtn);
  });
}

$(document).ready(() => {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  wrapDirections();

  modifyBtnNavToggle();
  searchBoxPlaceholder();

  // if is not homepage then modify featureLineup
  if (!$('body').hasClass('homepage')) {
    modifyFeatureLineup();
  }
});

$(window).load(() => {
  // ---
  wrapLogin();
  appendSEOTitle();
});
